import { jsx } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import { datadogRumInit } from '../../core/rum.js';
import { DatadogRumContext } from './context.js';

const DatadogRumProvider = ({ children, ...config })=>{
    const datadogRum = useMemo(()=>datadogRumInit(config), [
        config
    ]);
    useEffect(()=>{
        return ()=>{
            datadogRum?.clearGlobalContext();
        };
    }, [
        datadogRum
    ]);
    if (datadogRum == null) {
        console.warn('[DatadogRum]: DatadogRum failed to initialize');
    }
    return jsx(DatadogRumContext.Provider, {
        value: datadogRum,
        children: children
    });
};

export { DatadogRumProvider };
//# sourceMappingURL=provider.js.map
